import React from 'react'
import {
    FlatList,
    Dimensions
} from 'react-native'
import { VStack, HStack, Text, Box } from 'native-base'
import moment from 'moment'
import { useHeaderHeight } from '@react-navigation/stack'

export default function CreditList(props) {
    const { t, records } = props
    const headerHeight = useHeaderHeight();

    const renderMembersView = (object) => {
        const { item } = object
        const { credit, type, createdAt, remark, user } = item
        return (
            <VStack p={2}>
                <HStack justifyContent={'space-between'}>
                    <Text fontSize={'xs'} py={1}>{`${t('credit')}: ${credit}`}</Text>
                    <Text fontSize={'xs'} py={1}>{t(type)}</Text>
                </HStack>
                <Text fontSize={'xs'} py={1}>{`${t('name')}: ${user.username}`}</Text>
                <Text fontSize={'xs'} py={1}>{`${t('remark')}: ${remark ? remark : '--'}`}</Text>
                <Text fontSize={'xs'} py={1}>{t('date', { date: moment(createdAt).format('YYYY-MM-DD HH:mm') })}</Text>
            </VStack>
        )
    }


    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <FlatList
                ItemSeparatorComponent={() => {
                    return (
                        <Box
                            borderBottomWidth={1}
                            borderBottomColor={'gray.200'}
                        />
                    )
                }}
                onEndReached={() => props.onEndReached()}
                data={records}
                renderItem={(object) => renderMembersView(object)}
                keyExtractor={(item, index) => index.toString()}
            />
        </Box>
    )
}